import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    padding: '60px 0px',
    '& *': {
      textAlign: 'center'
    },
  },
  root: {
    display: 'flex',
    width: '100%',
    '& > div': {
      margin: '0'
    },
    '& button': {
      width: '100%'
    }
  },
  title: {
    color: theme.palette.error.main,
    fontSize: '1.25rem',
    fontWeight: 500
  },
  description: {
    color: theme.palette.primary.dark,
    fontSize: '14px',
    fontWeight: 500
  },
  medicationLink: {
    color: theme.palette.primary.light,
    fontSize: 20,
    fontWeight: 500
  },
  errorIconImage: {
    width: 110,
    height: 110,
    color: theme.palette.error.main
  }

}));
